import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import PublicLayout from "./components/PublicLayout";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import {
    ProductionsPage,
    EventsPage,
    CommunicationPage,
    CastingPage,
} from "./pages/StaticPages";
import { PrivacyPage, CookiePage } from "./pages/LegalPages";
import DetailPage from "./pages/DetailPage";
import TalentsPage from "./pages/TalentsPage";
import ContactPage from "./pages/ContactPage";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminList from "./pages/AdminList";
import AdminEditor from "./pages/AdminEditor";
import AdminContacts from "./pages/AdminContacts";
import UploadGate from "./pages/UploadGate";
import AdminPinGate from "./pages/AdminPinGate";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <CookieBanner />
                <Routes>
                    {/* Public */}
                    <Route element={<PublicLayout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/produzioni-tv" element={<ProductionsPage />} />
                        <Route
                            path="/produzioni-tv/:slug"
                            element={<DetailPage kind="productions" backTo="/produzioni-tv" backLabel="Produzioni TV" />}
                        />
                        <Route path="/eventi" element={<EventsPage />} />
                        <Route
                            path="/eventi/:slug"
                            element={<DetailPage kind="events" backTo="/eventi" backLabel="Eventi" />}
                        />
                        <Route path="/comunicazione" element={<CommunicationPage />} />
                        <Route path="/casting" element={<CastingPage />} />
                        <Route path="/talent-ospiti" element={<TalentsPage />} />
                        <Route
                            path="/talent-ospiti/:slug"
                            element={<DetailPage kind="talents" backTo="/talent-ospiti" backLabel="Talent & Ospiti" />}
                        />
                        <Route path="/contatti" element={<ContactPage />} />
                    </Route>

                    {/* Admin */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminPinGate />}>
                        <Route index element={<AdminDashboard />} />
                        <Route path="contacts" element={<AdminContacts />} />
                        <Route path=":kind" element={<AdminList />} />
                        <Route path=":kind/:id" element={<AdminEditor />} />
                    </Route>

                    {/* Direct-access upload shortcut (no login, no PIN) */}
                    <Route path="/upload" element={<UploadGate />}>
                        <Route index element={<AdminDashboard />} />
                        <Route path="contacts" element={<AdminContacts />} />
                        <Route path=":kind" element={<AdminList />} />
                        <Route path=":kind/:id" element={<AdminEditor />} />
                    </Route>

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
